import React from "react";
import styles from "../../styles/Home.module.css";
import { Box } from "@chakra-ui/react";
import { Sidebar } from "./Sidebar";

const Layout: React.FC<any> = (props: any) => {
  const { children } = props;

  return (
    <>
      <Sidebar />
      <Box pl={{ base: 0, lg: "260px" }} minH="100vh">
        <main id="main" className={styles.main}>
          {children}
        </main>
      </Box>
    </>
  );
};

export default Layout;
